<template>
  <div class="section-container">
    <div class="section-top">
      <div class="flex items-center">
        <p class="section-title mr-3">{{ title }}</p>
        <sf-icon @click="openModal" size="lg" :icon="['fas', 'info-circle']" :style="{ cursor: 'pointer', marginTop: '-3px' }" />
      </div>
      <p class="section-number">{{ step }}/{{ totalSteps }}</p>
    </div>
    <div class="section-bottom">
      <div class="flex mb-6" v-html="cardContent"></div>

      <ul>
        <li
          v-for="option in filteredOptions"
          :key="option.id"
          @click="setSelection(option)"
          class="list-select-item"
          :class="{ 'selected-list-select-item': isSelected(option) }"
        >
          <p>{{ option.variationName || option.name || '' }}</p>
          <p v-if="priceDifference(option)" class="font-bold bg-yellow-300 py-1 px-2 min-w-[112px] text-right">
            <span class="mr-1">{{ priceDifference(option) > 0 ? "+" : "-" }}</span
            >{{ Math.abs(priceDifference(option)) | formatPrice }} €
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { getAttributeValue } from "./plentyHelpers";
import { fetchCategoryContent } from "./Helpers";

export default {
  name: "Drive",
  props: ["category", "step", "totalSteps"],

  data() {
    return {
      modalContent: "",
      title: "Antrieb",
      cardContent: "",
    };
  },

  async created() {
    let { modalContent, title, cardContent } = await this.fetchCategoryContent(this.category, this.$setPreview);
    this.modalContent = modalContent;
    if (title) this.title = title;
    if (cardContent) this.cardContent = cardContent;
  },

  computed: {
    ...mapState("drive/", {
      options: (state) => state.options,
      selection: (state) => state.selection,
      defaultSelection: (state) => state.defaultSelection,
    }),

    setItemId() {
      return this.$store.state.set.setItem.id;
    },

    filteredOptions() {
      return this.options.filter((option) => {
        if (this.setItemId == 948 && option.id != 4232) return false; // B25 Volant only has Motor IO option 
        return true;
      });
    },
  },

  methods: {
    ...mapMutations("drive/", {
      setSelection: "setSelection",
    }),

    getAttributeValue,
    fetchCategoryContent,

    isSelected(option) {
      return this.selection.id === option.id;
    },

    priceDifference(option) {
      if (!this.selection) return 0;
      if (!this.selection.variationSalesPrices) return 0;

      let optionPrice = option.variationSalesPrices[0].price;
      let selectedPrice = this.selection.variationSalesPrices[0].price;
      return optionPrice - selectedPrice;
    },

    openModal() {
      this.$store.commit("modal/openModal")
      this.$store.dispatch("modal/setBody", this.modalContent);
      this.$store.dispatch("modal/setTitle", this.title);
    },
  },
};
</script>

<style></style>
